import ChatSection from '../components/ChatSection';

const Chat = () => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0, height: '100%' }}>
      <ChatSection />
    </div>
  );
};

export default Chat;
